import { lazy } from 'react';
export var TeamEditPageAsync = lazy(function () { return import('./TeamEditPage'); });
